import BlockedUsers from "@/views/CMS/BlockedUsers/BlockedUsers.vue";
const routes = [
    {
        path: "/admin/blocked-users/list",
        name: "BlockedUsers",
        component: BlockedUsers,
    },
];
export default routes;
